export const StorageModule = {
  set(name, data) {
    if (typeof data !== "string") {
      data = JSON.stringify(data);
    }
    try {
      window.localStorage.setItem(name, data);
    } catch (e) {
      console.log("setItem", e);
    }
  },
  get(name, trans) {
    let obj = localStorage.getItem(name) || "";
    if (trans) {
      try {
        obj = JSON.parse(obj);
      } catch (err) {}
    }
    return obj;
  },
  // 获取成事登录用户账号
  getUser() {
    const token = StorageModule.get("pl_token");
    const user = StorageModule.get("pl_userInfo", true);
    return {
      token,
      user,
    };
  },
  setToken(token) {
    StorageModule.set("pl_token", token);
  },
  setUser(userInfo) {
    StorageModule.set("pl_userInfo", userInfo);
  },
  // 获取分享用户
  getShareUser() {
    const token = StorageModule.get("share_token");
    const pass = StorageModule.get("share_pass");
    const ikey = StorageModule.get("share_ikey");
    const user = StorageModule.get("share_userInfo", true);
    return {
      token,
      user,
      pass,
      ikey,
    };
  },
  setShareUser({ token, userInfo, ikey, pass }) {
    StorageModule.set("share_token", token);
    StorageModule.set("share_userInfo", userInfo);
    StorageModule.set("share_pass", pass);
    StorageModule.set("share_ikey", ikey);
  },
  // 获取聊天
  getChatUser() {
    const token = StorageModule.get("chat_token");
    return {
      token,
    };
  },
  // 设置聊天用户
  setChatUser(token) {
    StorageModule.set("chat_token", token);
  },
  // 获取聊天
  getShareChatUser() {
    const token = StorageModule.get("sharechat_token") || window.sharechat_token || "";
    return {
      token,
    };
  },
  // 设置聊天用户
  setShareChatUser(token) {
    StorageModule.set("sharechat_token", token);
    window.sharechat_token = token;
  },
  getShareUid() {
    return StorageModule.get("share_userId");
  },
  setShareUid(id) {
    StorageModule.set("share_userId", id);
  },
  getShareName() {
    return StorageModule.get("share_userName");
  },
  setShareName(name) {
    StorageModule.set("share_userName", name);
  },
  getUuid() {
    return StorageModule.get("pl_uuid");
  },
  setUuid(uuid) {
    StorageModule.set("pl_uuid", uuid);
  },
  getDel() {
    return StorageModule.get("pl_del_the", true);
  },
  setDel(del) {
    StorageModule.set("pl_del_the", del);
  },
  getStop() {
    return StorageModule.get("pl_stop");
  },
  setStop(stop) {
    StorageModule.set("pl_stop", stop);
  },
  getStatus() {
    return StorageModule.get("pl_sync_status");
  },
  setStatus(status) {
    StorageModule.set("pl_sync_status", status);
  },
  getGeo() {
    return StorageModule.get("pl_placeholderGeo");
  },
  setGeo(geo) {
    StorageModule.set("pl_placeholderGeo", geo);
  },
  getToggle(uid) {
    return StorageModule.get(`pl_toggle_${uid}`);
  },
  setToggle(uid, type) {
    StorageModule.set(`pl_toggle_${uid}`, type);
  },
};
//当前页面监听localStorage的数据，能重写setItem方法
const originalSetItem = localStorage.setItem;
localStorage.setItem = function (key, newValue) {
  const setItemEvent = new Event("setItemEvent");
  setItemEvent[key] = newValue;
  window.dispatchEvent(setItemEvent);
  originalSetItem.apply(this, [key, newValue]);
};
